import React from 'react'

const Title = () => {
    return (
        <div>
            <title>Celeste Bolos Doces & Salgados - Home</title>           
        </div>
    )
}
export default Title